export const messages = {
  graphicCreateSuccess: 'The Graphic has been successfully created.',
  graphicUpdateSuccess: 'The Graphic has been successfully updated.',
  scheduleCreateSuccess: 'The schedule has been successfully created.',
  scheduleUpdateSuccess: 'The schedule has been successfully updated.',
  scheduleDeleteSuccess: 'The schedule has been successfully deleted.',
  scheduleMayBeDeletedFailure:
    'The schedule was not found. It may have been deleted by another user.',
  capabilityCreateSuccess: 'The capability has been successfully created.',
  capabilityUpdateSuccess: 'The capability has been successfully updated.',
  capabilityDeleteSuccess: 'The capability has been successfully deleted.',
  fileVerificationFailure:
    'The file you are uploading might contain malicious content.',
  fileValidationFailure:
    'This file type is not supported. Please choose a .png, .jpg or .jpeg file.',
  notAnImageError:
    'The clipboard does not contain an image. Try again or save the image to your PC and upload the file.',
  unsavedDataOnPackForm:
    "There are unsaved metadata changes that will be lost. Please click Save or Cancel via the 'Publish' tab to enable upload.",

  createEditionForDatachartCreateSuccess: (fileName: string): string =>
    `Edition for ${fileName} has been successfully created.`,
  createEditionForFileCreateSuccess: (fileName: string): string =>
    `Edition for file ${fileName} has been successfully created.`,
  createEditionForFileUpdateSuccess: (fileName: string): string =>
    `Edition for file ${fileName} has been successfully updated.`,
  createPackDeleteSuccess: (packName: string): string =>
    `${packName} pack has been successfully deleted.`,
  createFileDeleteSuccess: (name: string): string =>
    `${name} file has been successfully deleted.`,
  createGroupCreateSuccess: (name: string): string =>
    `Group ${name} has been successfully created.`,
  createGroupUpdateSuccess: (
    name: string,
    isAddedRequireApprovalCapability: boolean
  ): string =>
    `Group ${name} has been successfully updated.${
      isAddedRequireApprovalCapability
        ? ' An email has been sent to Global Approvers to approve new capability.'
        : ''
    }`,
  createGroupDeleteSuccess: (name: string): string =>
    `Group ${name} has been successfully deleted.`,
  createMediaTypeCreateSuccess: (name: string): string =>
    `Media Type ${name} has been successfully created.`,
  createMediaTypeUpdateSuccess: (name: string): string =>
    `Media Type ${name} has been successfully updated.`,
  createMediaTypeDeleteSuccess: (name: string): string =>
    `Media Type ${name} has been successfully deleted.`,
  createMediaTypeGroupCreateSuccess: (name: string): string =>
    `Media Type Group ${name} has been successfully created.`,
  createMediaTypeGroupUpdateSuccess: (name: string): string =>
    `Media Type Group ${name} has been successfully updated.`,
  createMediaTypeGroupDeleteSuccess: (name: string): string =>
    `Media Type Group ${name} has been successfully deleted.`,
}
